import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { useUserData } from "../../../../../core/router/hooks/useUserData";
import { BrandTextStyle, DataGroupNameStyle, UserDataContainer, UserNameStyle } from "../../../../../core/styles/TextStyles";
import { ProfilePopover } from "./ProfilePopover";

export const Header = () => {
    const [userName] = useUserData();
    const currentDataGroup = getAssignedDataGroup();

    return (
        <div className="aevi-header" style={{ zIndex: 1000 }}>
            <div className="aevi-header-left">
                <span className="aevi-header-image" />
                <BrandTextStyle>AP Admin</BrandTextStyle>
            </div>
            <div className="aevi-header-right">
                <UserDataContainer>
                    <UserNameStyle>{userName}</UserNameStyle>
                    {currentDataGroup ? <DataGroupNameStyle>{currentDataGroup?.name}</DataGroupNameStyle> : null}
                </UserDataContainer>
                <ProfilePopover />
            </div>
        </div>
    );
};
